import { Options } from 'vue-class-component';
import SceneWizardStep from '../SceneWizardStep';
import {
  isDefaultScene,
  NAME_VALIDATION_DEBOUNCE_TIME,
} from '@/core/utils/utils';
import debounce from 'lodash.debounce';
import { NamingService } from '@/core/services/naming.service';
import { SET_APP_LOADING } from '@/core/store/action-types';
import { PlantEntityType } from '@/../client-generator/generated-clients/configurations';

@Options({
  name: 'SceneWizardStep1',
  watch: {
    'scene.name': function () {
      this.verifyValidityOfName();
    },
  },
})
export default class SceneWizardStep1 extends SceneWizardStep {
  isValidName = true;
  initialName!: string;
  invalidNameReason: string = '';

  isDefaultScene = isDefaultScene;

  async mounted() {
    if (this.isEditMode()) {
      this.initialName = this.scene.name ?? '';
    } else {
      this.computeSceneName();
    }

    this.verifyValidityOfName = debounce(
      this.verifyValidityOfName,
      NAME_VALIDATION_DEBOUNCE_TIME
    );

    NamingService.flushCache();
    await NamingService.prefetchFlatEntities(
      this.plantId,
      PlantEntityType.SCENE
    );
  }

  private async verifyValidityOfName() {
    this.$store.dispatch(SET_APP_LOADING, true);
    const validName = NamingService.isValidEntityTypeName(this.scene.name);
    if (this.initialName !== this.scene.name && !validName) {
      const suggestedName = await NamingService.suggestNextValidEntityName({
        plantId: this.plantId,
        eType: PlantEntityType.SCENE,
      });
      this.isValidName = validName;
      this.invalidNameReason = this.$t(
        `uniqueNaming.validationErrorWithSuggestion`,
        { suggestedName }
      );
      this.$emit('next-enabled', false);
    } else {
      this.isValidName = true;
      this.invalidNameReason = '';
      this.$emit('next-enabled', true);
    }
    this.$store.dispatch(SET_APP_LOADING, false);
  }

  private isEditMode(): boolean {
    return !!this.scene.id && !!this.scene.id.trim().length;
  }

  private async computeSceneName() {
    this.$store.dispatch(SET_APP_LOADING, true);
    this.scene.name = await NamingService.suggestNextValidEntityName({
      plantId: this.plantId,
      eType: PlantEntityType.SCENE,
    });
    this.$store.dispatch(SET_APP_LOADING, false);
  }
}
